import { render, staticRenderFns } from "./LoadOverviewChart.vue?vue&type=template&id=af5065c6&scoped=true"
import script from "./LoadOverviewChart.vue?vue&type=script&lang=js"
export * from "./LoadOverviewChart.vue?vue&type=script&lang=js"
import style0 from "./LoadOverviewChart.vue?vue&type=style&index=0&id=af5065c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5065c6",
  null
  
)

export default component.exports